import Vue from 'vue'
import App from './App'
import router from './router'
import req from './config/requ.axios.config'
// import requReq from './config/requ.axios.config'
import Mint from 'mint-ui'
import store from './store'
import title from 'vue-wechat-title'
import mintcss from './assets/stylesheets/scss/selfmint.scss'

// import 'mint-ui/lib/style.css'
// import './config/axios.config'
import images from './config/images.config'

Vue.use(Mint)
Vue.use(title)
Vue.use(mintcss)
Vue.config.productionTip = false
Vue.prototype.$isAndroid = /android/g.test(navigator.userAgent.toLowerCase())
Vue.prototype.$http = req
Vue.prototype.$images = images

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js